var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEye = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.5284C1.98275 10.5284 0.112966 5.92957 0.0350584 5.73671C-0.0116861 5.6032 -0.0116861 5.45485 0.0350584 5.32134C0.112966 5.11365 1.98275 0.5 7 0.5C12.0173 0.5 13.887 5.09881 13.9649 5.29167C14.0117 5.42518 14.0117 5.57353 13.9649 5.70704C13.887 5.91473 12.0173 10.5284 7 10.5284ZM7 7.73942C8.29327 7.73942 9.33723 6.74549 9.33723 5.51419C9.33723 4.28289 8.29327 3.28896 7 3.28896C5.70673 3.28896 4.66277 4.28289 4.66277 5.51419C4.66277 6.74549 5.70673 7.73942 7 7.73942ZM7 4.47575C6.39232 4.47575 5.90929 4.93563 5.90929 5.51419C5.90929 6.09275 6.39232 6.55263 7 6.55263C7.60768 6.55263 8.09071 6.09275 8.09071 5.51419C8.09071 4.93563 7.60768 4.47575 7 4.47575Z",
    fill: "#06251E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEye, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/eye.5f4ed899.svg";
export { ForwardRef as ReactComponent };